/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class UserForm extends React.Component {
  onVerify = (e) => {
    e.preventDefault();
    const username1 = document.getElementById('input1Mail').value.trim();
    const password1 = document.getElementById('input1Password').value.trim();
    const host1 = document.getElementById('input1ServerUrl').value.trim();
    const username2 = document.getElementById('input2Mail').value.trim();
    const password2 = document.getElementById('input2Password').value.trim();
    const host2 = document.getElementById('input2ServerUrl').value.trim();
    console.log(host2);
    const ssl = this.props.sslBool;
    if (username1 === username2 && host1 === host2) this.props.setCorrectData({ correctDataState: 'incorrect' });
    else if (!username1 || !password1 || !host1 || !username2 || !password2) this.props.setCorrectData({ correctDataState: 'incorrect' });
    else {
      this.props.sendVerifyData({
        username1, password1, host1, username2, password2, host2, ssl,
      });
    }
  }

  onChange = () => {
    this.props.setCorrectData({ correctDataState: 'changed' });
  }

  onClickSsl = () => {
    this.props.setSslCheck({ sslBool: !this.props.sslBool });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const username1 = document.getElementById('input1Mail').value.trim();
    const password1 = document.getElementById('input1Password').value.trim();
    const host1 = document.getElementById('input1ServerUrl').value.trim();
    const username2 = document.getElementById('input2Mail').value.trim();
    const password2 = document.getElementById('input2Password').value.trim();
    const host2 = document.getElementById('input2ServerUrl').value.trim();
    const mail = document.getElementById('personalMail').value.trim();
    const ssl = this.props.sslBool;
    const data = {
      usr1: username1,
      passwd1: password1,
      hst1: host1,
      usr2: username2,
      passwd2: password2,
      hst2: host2,
      email: mail,
      ssl,
    };
    this.props.sendData(data);
  }

  renderCorrectMessage(state) {
    let p;
    if (state === 'correct') p = <p className="text-success"><FontAwesomeIcon icon="user-check" /> I dati risultano corretti, ora puoi procedere con la sincronizzazione cliccando sul tasto Sincronizza.</p>;
    if (state === 'incorrect') p = <p className="text-danger"><FontAwesomeIcon icon="user-times" /> Alcuni dati risultano errati, riprova.</p>;
    if (state === 'changed') p = null;

    return (<div className="row">
  <div className="col">
  {p}
      </div>
    </div>);
  }

  render() {
    const { correctDataState, sendVerifyState, sslBool } = this.props;


    return <div className="col-12">
    <form onSubmit={this.onSubmit}>
      <div className="form-row">

      <div className="col-md-6 col-sm-12">
      <h3 className="font-weight-bold">Account sorgente <FontAwesomeIcon icon="user-circle"/></h3>
  <div className="form-group">
    <label htmlFor="input1Mail"><FontAwesomeIcon icon="envelope" /> Username</label>
    <input type="text" className="form-control" id="input1Mail" placeholder="Potrebbe coincidere con il tuo indirizzo e-mail" onChange={this.onChange} required></input>
  </div>
  <div className="form-group">
    <label htmlFor="input1Password"><FontAwesomeIcon icon="key" /> Password</label>
    <input type="password" className="form-control" id="input1Password" onChange={this.onChange} required></input>
  </div>
  
  <label htmlFor="input1ServerUrl"><FontAwesomeIcon icon="server" /> Server IMAP</label>
  <div className="input-group">  
    <input type="text" className="form-control" id="input1ServerUrl" onChange={this.onChange} required></input>
    <div className="input-group-append">
    <div className="input-group-text">
  <input type="checkbox" id="input1Ssl" onClick={this.onClickSsl} onChange={this.onChange} checked={sslBool}></input>
  </div>
  <span className="input-group-text"> SSL</span>
  </div>
  </div>
  </div>

  <div className="col-md-6 col-sm-12">
  <h3 className="font-weight-bold">Account di destinazione <FontAwesomeIcon icon="user-circle"/></h3>
  <div className="form-group">
    <label htmlFor="input2Mail"><FontAwesomeIcon icon="envelope" /> Email address</label>
    <input type="email" className="form-control" id="input2Mail" onChange={this.onChange} required></input>
  </div>
  <div className="form-group">
    <label htmlFor="input2Password"><FontAwesomeIcon icon="key" /> Password</label>
    <input type="password" className="form-control" id="input2Password" onChange={this.onChange} required></input>
  </div>
  <div className="form-group">
    <label htmlFor="input2ServerUrl"><FontAwesomeIcon icon="server" /> Server IMAP</label>
    <select className="form-control" id="input2ServerUrl" onChange={this.onChange}>
    <option value="imap.rhx.it">imap.rhx.it</option>
    <option value="imap.netech.net">imap.netech.net</option>
    <option value="imap.bitname.net">imap.bitname.net</option>
    <option value="mbox.cert.legalmail.it">mbox.cert.legalmail.it</option>
    <option value="m.mercuriosistemi.com">m.mercuriosistemi.com</option>
    <option value="mail.scuolaedilebelluno.it">mail.scuolaedilebelluno.it</option>
    </select>
  </div>

  </div>


  </div>

  <div className="row">
  <div className="col-12">
  <div className="form-group">
  <label htmlFor="personalMail"><FontAwesomeIcon icon="paper-plane" /> Indirizzo e-mail per report</label>
  <input id="personalMail" type="email" className="form-control" placeholder="my@mail.com" required></input>
  <small className="form-text text-muted">Inserisci un indirizzo email dove ricevere le notifiche relative alla migrazione</small>
  </div>
  </div>
  </div>

  {this.renderCorrectMessage(correctDataState)}
  <div className="row">
  <div className="col-md-2 d-none d-md-block">
      <button type="button" className="btn btn-dark" onClick={this.onVerify} disabled={ sendVerifyState === 'requested'} ><FontAwesomeIcon icon="user-cog"/> Verifica i dati</button>
      </div>
      <div className="col d-md-none ">
      <button type="button" className="btn btn-dark" onClick={this.onVerify} disabled={ sendVerifyState === 'requested'} ><FontAwesomeIcon icon="user-cog"/></button>
      </div>
  <div className="col-md-2 d-none d-md-block ml-1">
  <button type="submit" className="btn btn-dark" disabled={ correctDataState !== 'correct'}><FontAwesomeIcon icon="sync" /> Sincronizza</button>
  </div>
  <div className="col d-md-none">
  <button type="submit" className="btn btn-dark" disabled={ correctDataState !== 'correct'}><FontAwesomeIcon icon="sync" /></button>
  </div>
      </div>

</form>
    </div>;
  }
}
